/**
 * File lightbox.js
 * Adds lightbox to WordPress gallery blocks.
 */

(async () => {
    if (document.querySelector('[data-glightbox], .wp-block-gallery img, .gallery-item')) {
        await import('glightbox/dist/css/glightbox.min.css');
        const { default: GLightbox } = await import('glightbox');

        const lightbox = GLightbox({
            selector: 'data-glightbox',
            touchNavigation: true,
            closeOnOutsideClick: true,
        });

        document.querySelectorAll('.wp-block-gallery img, .gallery-item').forEach((image) => {
            let src;
            if (image.hasAttribute('data-srcset')) {
                const srcset = image.getAttribute('data-srcset').split(", ");
                src = srcset[0].split(" ")[0];
            } else if (image.hasAttribute('srcset')) {
                const srcset = image.getAttribute('srcset').split(", ");
                src = srcset[0].split(" ")[0];
            } else {
                src = image.getAttribute('src');
            }

            let a;
            const hasLink = image.parentElement.nodeName === 'A';
            if (hasLink) {
                a = image.parentElement;
            } else {
                a = document.createElement("a");
            }
            a.setAttribute('href', src);
            a.setAttribute('data-glightbox', 'image');

            if ( !hasLink ) {
                image.parentNode.insertBefore(a, image);
                a.appendChild(image);
            }
        });

        lightbox.reload();

        lightbox.on('open', () => {
            const overlay = document.querySelector('.glightbox-container');
            if (!overlay) return;
            const handler = (e) => {
                if (e.target.classList.contains('ginner-container')) {
                    lightbox.close();
                }
            };

            overlay.addEventListener('touchend', handler);
            overlay.addEventListener('click', handler);
            lightbox.on('close', () => {
                overlay.removeEventListener('touchend', handler);
                overlay.removeEventListener('click', handler);
            });
        });
    }
})();